module.exports = "/static/assets/809352dde32b1195a44711f5f5b933c2.png";